import React, { memo } from "react"
import PropTypes from "prop-types"

import { Text } from "ui/Typography"
import { Tag, Button } from "antd"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import styles from "./index.module.css"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"

const BookingItem = ({ booking, conflict = false, setIsBookingModalOpen, setSelectedBookingId }) => {
  const { formatted_start_time, formatted_end_time, uuid, title, payment_status } = booking || {}
  let eventTime = formatted_start_time || ""
  if (formatted_end_time) {
    eventTime += " - " + formatted_end_time
  }
  const color = getEventColor(payment_status)

  const handleBookingClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(uuid)
  }

  return (
    <Button type="link" className={`px-0 border-0 ${styles.eventWrapper}`} onClick={handleBookingClick}>
      <Tag className={`p-xs rounded-xs m-0 ${styles.tag}`} style={{ backgroundColor: color }}>
        {eventTime && (
          <>
            <span className={styles.timeRow}>
              <Text className={`ellipsis ${styles.ellipsisText}`}>{eventTime}</Text>
              {conflict ? <BookingConflictWarning /> : null}
            </span>
            <br />
          </>
        )}
        <Text className={`ellipsis ${styles.ellipsisText}`}>{title}</Text>
      </Tag>
    </Button>
  )
}

BookingItem.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    payment_status: PropTypes.string,
    title: PropTypes.string.isRequired,
    formatted_start_time: PropTypes.string,
    formatted_end_time: PropTypes.string
  }).isRequired,
  conflict: PropTypes.bool,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
}

export default memo(BookingItem)
